import { api } from './api'

export const deleteBusinessRegistration = (userId: number) =>
  api.delete(`/business_accounts/${userId}`)
